export default function (context) {
    context.store.$dialog = context.$dialog;
}
//# sourceMappingURL=vuetify-dialog.js.map